import React,{ Component } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';

import moment from 'moment';

import Button from '../../../shared/components/Button';
import MoneyDisplay from '../../../shared/components/MoneyDisplay';
import SearchableDataTable from '../../../shared/components/SearchableDataTable';
import DropdownButton from '../../../shared/components/DropdownButton';

import {  
  firstNonZeroOrOne,
  alphabeticallySort,
  textContains,
  statusSort,
  daysSinceEpoch,
  dayIsInPast
} from '../../../shared/utils';

class ProviderPromoCodeList extends Component {
  constructor(){
    super();

    this.state = {
      isLoaded:false,
      error:null
    };
  }

  componentDidMount(){
    //TODO: Load data from server for ProviderPromoCodeList in componentDidMount
    this.props.loadPromoCodes()
      .then(() => this.setState({isLoaded:true}))
      .catch((err) => this.setState({error:err}));
  }

  componentWillUnmount(){
    //TODO: Cleanup after ProviderPromoCodeList in componentWillUnmount
  }

  render(){
    const { promoCodes, deletePromoCode } = this.props;

    return (
      <Row>
        <Col xs='12'>
          <SearchableDataTable 
            items={promoCodes}
            emptyText='Loading promo codes...'
            searchPromptText='Search by code'
            isActiveFunc={(item) => !dayIsInPast(item.expirationDate)}    
            columns={[
              {
                name:'code',
                width:30,
                filterFunc:(a,searchParam) => textContains(a.code,searchParam),
                sortFunc:(a,b) => firstNonZeroOrOne([
                  alphabeticallySort(a.code, b.code),
                ]), 
                renderCell:(item) => (<strong>{item.code}</strong>)
              },
              {
                name:'amount',
                width:30,
                sortFunc:(a,b) => firstNonZeroOrOne([
                  b.amount - a.amount,
                  alphabeticallySort(a.code,b.code)
                ]),
                renderCell:(item) => (<MoneyDisplay>{item.amount}</MoneyDisplay>)
              },
              {
                name:'expirationDate',
                display:'Expiration Date',
                width:30,
                sortFunc:(a,b) => firstNonZeroOrOne([
                  daysSinceEpoch(b.expirationDate) - daysSinceEpoch(a.expirationDate),
                  alphabeticallySort(a.code,b.code)
                ]),
                renderCell:(item) => (<span>{moment(item.expirationDate).format('h:mm a, MMM D, YYYY')}</span>)
              },{
                width:20,
                alwaysActive:true,
                renderCell:(item) => (
                  <div className='pull-right'>
                    <Button
                      linkHref={`/superadmin/configuration/promocodes/${item.id}/edit`}
                      size='sm'
                      textColor='#666666'
                      borderColor='#cccccc'
                      backgroundColor='#fff'
                    >
                      Edit
                    </Button>
                    &nbsp;&nbsp;
                    <DropdownButton 
                      options={[
                        {
                          text:'Move to trash', 
                          confirmationText:'This is permanent and can not be reverted.',
                          confirmationAcceptText:'Confirm',
                          confirmationRejectText:'Cancel',
                          onClick:() => deletePromoCode(item.id)
                        }
                      ]} 
                    />
                  </div>
                )
              }
            ]}        
          />
        </Col>
      </Row>
    );
  }
}

ProviderPromoCodeList.propTypes = {
  //TODO: Fill in prop types for ProviderPromoCodeList
};

ProviderPromoCodeList.defaultProps = {
  //TODO: Fill in defaultProps for ProviderPromoCodeList
};

export default ProviderPromoCodeList;



// WEBPACK FOOTER //
// ./src/routes/ProviderPromoCodeList/components/ProviderPromoCodeList.js